<template>
<div>
    <draggable
        :list="obtenerListaDeContenidosOriginal"
        :disabled="!habilitado"
        :scroll-sensitivity="50"
        :force-fallback="false"
        id="listaOrdenable_arrastrable"
        class="listaOrdenable"
        handle=".contenidoLista-titulo-texto"
        dragClass="listaOrdenable-arrastra"
        chosenClass="listaOrdenable-selecciona" 
        ghost-class="listaOrdenable-fantasma"
        @start="arrastrando = true"
        @end="finalizoArrastre"
    >
  
        <div v-bind:class="[arrastrando?'listaOrdenable-arrastra':'listaOrdenable-hover','contenidoLista']" v-for="elementoContenidos in obtenerListaDeContenidosOriginal" :key="elementoContenidos.id" @mouseover="elementoContenidos.hover = true" @mouseleave="elementoContenidos.hover = false">
            <div v-bind:class="[elementoContenidos.hover ? 'contenidoLista-hover contenidoLista-scroll' : 'contenidoLista-no-hover contenidoLista-scroll']">
                <div class="contenidoLista-titulo-texto">
                    <h6 ><b>#Folio: {{elementoContenidos.ComunicadoMicrositio}}</b> <br>[ <i class="far fa-calendar-alt"></i> Fecha de publicación: {{ obtenerFechaConFormato(elementoContenidos.FechaDePublicacion) }}] <br> {{ elementoContenidos.Titulo != null ? reemplazaCaracteresEspeciales(elementoContenidos.Titulo, elementoContenidos.ComunicadoMicrositio) : elementoContenidos.Titulo}}</h6>
                </div>
            </div>
            <div v-if="elementoContenidos.mostrarDescripcion" v-bind:class="[elementoContenidos.hover ? 'contenidoLista-hover' : 'contenidoLista-no-hover']" >
            </div>
        </div>
    </draggable>  
</div> 
</template>

<script>
    import enumeraciones from '@/../static/js/enumeraciones'
    import api from '@/../static/js/api'
    import comun from '@/../static/js/comun'
    import axios from 'axios'
    import draggable from "vuedraggable";
    import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

 
    export default {

        directives: {
            tooltipF
        },
        components: {
            draggable
        },
        data() {
            return {
                habilitado: true,
                editado: false,
                arrastrando: false,
                listadoElementosOrdenados:[],
                formularioComunicado: 'comunicado',
            };
        },
        computed: {
            obtenerInformacionDePintado() {
                return this.arrastrando ? "under drag" : "";
            },
            obtenerListaDeContenidosOriginal() {
                // this.ordenarDesc(this.$store.getters.Get_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal,'contenido.OrdenDelContenido')
              //return this.$store.getters.Get_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal;
              console.log("computed:::",this.$store.getters.Get_SICPO_Micrositio_ComunicadosOrden)
               return this.$store.getters.Get_SICPO_Micrositio_ComunicadosOrden;
            },
            obtenerFormatoDeSeccion() {            
                return this.$store.getters.Get_SICPO_Catalogo_FormatoDeSeccion.valor;
            }
        },
        methods: {

          
            obtenerFechaConFormato: function(fecha){
                moment.lang("es");
                return moment(fecha).format('DD MMMM YYYY');
            },
            /**
             * Método encargado de reemplazar el caracter especial "¶" de consejeros, y/ o agregar más en caso de requerirse.  
             * @param {String} textoDelContenido [evento emitido por el draggable]
             */
            reemplazaCaracteresEspeciales: function(textoDelContenido){
                let seccionId = this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_punteroDeContenidoActual.seccionCrearContenidoId;
                return seccionId == 3? textoDelContenido.replace("¶", " - Designado por: ") : textoDelContenido;
            },
            /**
             * Metodo encargado de restablecer el orden de los contenidos en base la interaccion del usuario
             * con los items del draggable.  
             * @param {Object} e [evento emitido por el draggable]
             */
            finalizoArrastre: function(e) {
                this.arrastrando = false;
                
                let listado = this.obtenerListaDeContenidosOriginal;
                this.editado = false
                for(var i=0;i<listado.length;i++){
                    if(listado[i].Orden != i+1)
                        this.editado = true;
                    if(i<3)
                        listado[i].conIconoMostrarEnInicio = true;
                    else 
                        listado[i].conIconoMostrarEnInicio = false;
                }
                this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos",this.editado);
                this.$store.dispatch("A_SICPO_Micrositio_ComunicadosOrden",this.obtenerListaDeContenidosOriginal);
            console.log("nuevo orden:::",listado)
            },

            
        }
    }
</script>

<style scoped>
    .contenidoLista
    {
        position: relative;
        background: none;
        border: none;
        padding: 1%;
        width: 100%;
    }
    .contenidoLista-no-hover
    {
        background-color: #323335;
        border: 1px solid #FFFFFF;
        color: #FFFFFF;
        padding: 0.5em;
        white-space: pre-line;
    }
    .contenidoLista-hover
    {
        background-color: #FFFFFF;
        border: 1px solid #000000;
        color: black;
        padding: 0.5em;
        white-space: pre-line;
    }
    .contenidoLista-titulo-texto
    {
        display: inline-block;
        cursor: move;
        min-width: 70%;
        max-width: 90%;
        user-select: none;
        white-space: pre-line;
    }

    .contenidoLista-scroll {
        overflow-y: auto;
        max-height: 80px;
        
    }
  
    .contenidoLista-titulo-icono
    {
        right: 0px;
        float: right;
        height: 100%;
        padding-left: 5px;
        cursor: pointer;
        margin-right: 1em;
    }
    .contenidoLista-iconos-extras
    {
        right: 0px;
        float: right;
        height: 100%;
        padding: 3px;
        margin-left: 0.4em;
        margin-right: 1em;
    }

    .contenidoLista-iconos-extras i
    {
        padding: 0.3em;
    }

    .listaOrdenable_div
    {
        background-color: #57585B;
        padding: 0.5%;
    }
    #listaOrdenable_arrastrable
    {
        background: #57585B ;
        max-height: 100%;
        padding: 5px;
    }
    .listaOrdenable-selecciona{
        opacity: 0.4;
    }
    .listaOrdenable-fantasma{
        opacity: 1;
        background:cadetblue;/*#323335;*/
    }
    .listaOrdenable-arrastra {
        opacity: 0.4;
    }
    h6{
        white-space: pre-line;
    }
    .tabla-listado-archivos{
        border-collapse: collapse;
        width: 100%;
        background-color: #26272b;
    }

    .tabla-listado-archivos th {
        top: 0;
        background: #474749;
        border: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/ListaOrdenComunicados.vue